import Typography from '@mui/material/Typography';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import { getShortString } from 'lib/functions/utils';
import React from 'react';

interface KeyValueRowProps {
  label: string;
  value: string;
  labelFontSize?: number;
  valueFontSize?: number;
  labelFontWeight?: number;
  valueFontWeight?: number;
  valueMaxLength?: number;
}

const KeyValueRow = (props: KeyValueRowProps) => {
  const {
    label,
    value,
    labelFontSize = 16,
    valueFontSize = 16,
    labelFontWeight = 600,
    valueFontWeight = 400,
    valueMaxLength = 25,
  } = props;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <Typography fontSize={labelFontSize} fontWeight={labelFontWeight}>
        {label}:
      </Typography>
      <Typography fontSize={valueFontSize} fontWeight={valueFontWeight}>
        <LightTooltip title={value}>
          <Typography>{getShortString(value, valueMaxLength)}</Typography>
        </LightTooltip>
      </Typography>
    </div>
  );
};

export default KeyValueRow;
